import React, { useState, useEffect } from 'react';
import './Sessions.css'; // Your session-specific styles

// The base HTML template with inline styles for perfect rendering in email clients.
const emailTemplateString = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Your Session is Confirmed | GetNextVisa</title>
  {/* ... All the HTML and CSS from the previous correct answer ... */}
</head>
<body style="margin:0;padding:0;background-color:#f0f5f9;font-family:Arial,sans-serif;">

  <!-- WRAPPER -->
  <table border="0" width="100%" cellspacing="0" cellpadding="0" bgcolor="#f0f5f9">
    <tr>
      <td style="padding:30px 10px;" align="center">

        <!-- CONTENT CONTAINER -->
        <table class="container"
               role="presentation"
               width="580" cellspacing="0" cellpadding="0" border="0"
               style="width:100%;max-width:580px;margin:0 auto;border-collapse:collapse;">

          <!-- CARD -->
          <tr>
            <td class="card"
                bgcolor="#ffffff"
                style="border:1px solid #e2e8f0;border-radius:16px;padding:30px;overflow:hidden;">

              <!-- LOGO -->
              <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tr>
                  <td align="center" style="padding-bottom:20px;">
                    <img class="logo responsive"
                         style="display:block;border:0;outline:none;text-decoration:none;height:auto;"
                         src="https://getnextvisa.com/photos/heading.png"
                         alt="GetNextVisa Logo" width="160" />
                  </td>
                </tr>
              </table>

              <!-- HERO IMAGE -->
              <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tr>
                  <td align="center" style="padding-bottom:25px;">
                    <img class="responsive"
                         style="display:block;border:0;outline:none;text-decoration:none;height:auto;"
                         src="https://gnv.indraq.info/photos/counselling-booked.png"
                         alt="Consultation Illustration" width="200" />
                  </td>
                </tr>
              </table>

              <!-- HEADLINE -->
              <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tr>
                  <td align="center" style="padding-bottom:20px;">
                    <h1 style="margin:0;font-size:28px;color:#be0b32;line-height:1.2;">Session Booked</h1>
                    <h1 style="margin:0;font-size:28px;color:#0a3b5c;line-height:1.2;">Let’s Grab a Coffee & Chat</h1>
                    <p style="margin:8px 0 0;font-size:16px;color:#7f8c8d;">
                      Your session with a GetNextVisa expert is confirmed.
                    </p>
                  </td>
                </tr>
              </table>

              <!-- SAVE THE DATE -->
              <table style="border-top:1px solid #e2e8f0;border-bottom:1px solid #e2e8f0;padding:20px 0;" border="0" width="100%" cellspacing="0" cellpadding="0">
                <tr>
                  <td align="center">
                    <p style="margin:0 0 15px;font-size:14px;font-weight:bold;color:#0a3b5c;
                              text-transform:uppercase;letter-spacing:1px;">
                      Save the Date
                    </p>
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <!-- GOOGLE -->
                        <td align="center" style="padding:0 5px;">
                          <a href="{{googleCalendarLink}}" target="_blank"
                             style="display:inline-block;background-color:#f0f0f0;color:#0a3b5c;
                                    padding:8px 12px;border-radius:8px;text-decoration:none;
                                    font-size:13px;font-weight:600;">
                            <img src="https://indraq.com/wp-content/uploads/2025/07/7123030_google_calendar_icon-scaled.png"
                                 alt="G" width="25"
                                 style="vertical-align:middle;margin-right:4px;"/>
                            Google
                          </a>
                        </td>
                        <!-- OUTLOOK -->
                        <td align="center" style="padding:0 5px;">
                          <a href="{{outlookCalendarLink}}" target="_blank"
                             style="display:inline-block;background-color:#f0f0f0;color:#0a3b5c;
                                    padding:8px 12px;border-radius:8px;text-decoration:none;
                                    font-size:13px;font-weight:600;">
                            <img src="https://veevart.my.site.com/support/servlet/rtaImage?eid=ka0Vs000000c3bB&feoid=00Nf200000E0J7s&refid=0EMVs000001gMQA"
                                 alt="O" width="25"
                                 style="vertical-align:middle;margin-right:4px;"/>
                            Outlook
                          </a>
                        </td>
                        
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <!-- DETAILS -->
              <table class="details" role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0"
                     style="border-collapse:collapse;padding:20px 30px;">
                <tr>
                  <td style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:14px;color:#888;">Your Host</p>
                  </td>
                  <td align="right" style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:15px;font-weight:600;color:#0a3b5c;">{{counsellorName}}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:14px;color:#888;">Topic</p>
                  </td>
                  <td align="right" style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:15px;font-weight:600;color:#0a3b5c;">{{meetingTopic}}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:14px;color:#888;">Date & Time</p>
                  </td>
                  <td align="right" style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:15px;font-weight:600;color:#0a3b5c;">{{meetingDateTime}}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:14px;color:#888;">Duration</p>
                  </td>
                  <td align="right" style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:15px;font-weight:600;color:#0a3b5c;">{{meetingDuration}}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:14px;color:#888;">Platform</p>
                  </td>
                  <td align="right" style="padding:12px 0;border-top:1px solid #e2e8f0;">
                    <p style="margin:0;font-size:15px;font-weight:600;color:#0a3b5c;">{{platformName}}</p>
                  </td>
                </tr>
              </table>

              <!-- CTAs -->
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin:0 auto 30px;">
                <tr>
                  <td align="center">
                    <a class="cta" href="{{meetingLink}}" style="display:inline-block;background-color:#be0b32;color:#ffffff;padding:14px 20px;border-radius:12px;text-decoration:none;font-size:16px;font-weight:bold;margin:0 5px;min-width:140px;text-align:center;">Join Session</a>
                    <a class="cta" href="{{rescheduleLink}}" style="display:inline-block;background-color:transparent;color:#888;padding:14px 20px;border:2px solid #CFD8E1;border-radius:12px;text-decoration:none;font-size:16px;font-weight:bold;margin:0 5px;min-width:140px;text-align:center;">Reschedule</a>
                  </td>
                </tr>
              </table>

            </td>
          </tr>

        </table>

        <!-- FOOTER -->
        <table class="footer" style="width:100%;max-width:580px;margin:0 auto;border-collapse:collapse;" border="0" width="580" cellspacing="0" cellpadding="0">
          <tr>
            <td align="center" style="padding:30px;font-size:13px;color:#8492a6;line-height:1.6;">
              <p style="margin:0;">If you have any questions, please <a href="mailto:info@getnextvisa.com" style="color:#0a3b5c;text-decoration:underline;font-weight:600;">contact our support team.</a></p>
              <p style="margin:15px 0 0;">© 2025 GetNextVisa. All Rights Reserved.</p>
            </td>
          </tr>
        </table>

      </td>
    </tr>
  </table>

</body>
</html>
`;


/**
 * Generates a Google Calendar event link from session data.
 * @param {object} session - The session details object.
 * @returns {string} The generated Google Calendar URL.
 */
const generateGoogleCalendarLink = (session) => {
    const startTime = new Date(session.dateTime);
    const durationMinutes = parseInt(session.duration, 10) || 30;
    const endTime = new Date(startTime.getTime() + durationMinutes * 60000);

    // Format dates to YYYYMMDDTHHMMSSZ as required by Google Calendar
    // .toISOString() -> "2024-07-29T10:30:00.000Z"
    // We need to remove -, :, and .
    const formatToGoogleDate = (date) => date.toISOString().replace(/[-:.]/g, '');
    const googleStartTime = formatToGoogleDate(startTime).slice(0, -4) + 'Z';
    const googleEndTime = formatToGoogleDate(endTime).slice(0, -4) + 'Z';

    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: session.subject || 'GetNextVisa Counselling Session',
        dates: `${googleStartTime}/${googleEndTime}`,
        details: `Your counselling session with a GetNextVisa expert.\n\nJoin here: ${session.zoomMeetingLink}`,
        location: session.zoomMeetingLink || 'Online',
        ctz: 'UTC' // It's best to use UTC to avoid timezone issues
    });

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

/**
 * Generates an Outlook Calendar event link from session data.
 * @param {object} session - The session details object.
 * @returns {string} The generated Outlook Calendar URL.
 */
const generateOutlookCalendarLink = (session) => {
    const startTime = new Date(session.dateTime);
    const durationMinutes = parseInt(session.duration, 10) || 30;
    const endTime = new Date(startTime.getTime() + durationMinutes * 60000);
    
    // Outlook uses a different URL structure but standard ISO 8601 format is reliable
    const params = new URLSearchParams({
        path: '/calendar/action/compose',
        rru: 'addevent',
        startdt: startTime.toISOString(),
        enddt: endTime.toISOString(),
        subject: session.subject || 'GetNextVisa Counselling Session',
        body: `Your counselling session with a GetNextVisa expert.<br><br>Join here: <a href="${session.zoomMeetingLink}">${session.zoomMeetingLink}</a>`,
        location: session.zoomMeetingLink || 'Online'
    });

    return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
};

// Helper function to populate the template with data
const generatePopulatedHtml = (session, customMessage = "This is a friendly reminder for your scheduled session.") => {
    const sessionDateTime = session.dateTime ? new Date(session.dateTime) : new Date();
    
    const googleLink = generateGoogleCalendarLink(session);
    const outlookLink = generateOutlookCalendarLink(session);
    // For the 'Other' button, you might provide a downloadable .ics file, 
    // which is more complex to generate on the fly without a library or backend service.
    // For now, we can make it point to the Google link as a fallback.
    const otherLink = googleLink; 

    return emailTemplateString
      .replace(/{{studentName}}/g, session.studentName || 'Client')
      .replace(/{{customMessage}}/g, customMessage)
      .replace(/{{sessionSubject}}/g, session.subject || 'N/A')
      .replace(/{{sessionDate}}/g, sessionDateTime.toLocaleDateString('en-GB'))
      .replace(/{{sessionTime}}/g, sessionDateTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }))
      .replace(/{{sessionDuration}}/g, session.duration || '30')
      .replace(/{{sessionMode}}/g, session.mode || 'Video')
      .replace(/{{meetingLink}}/g, session.zoomMeetingLink || '#')
      .replace(/{{rescheduleLink}}/g, session.rescheduleLink || '#')
      .replace(/{{currentYear}}/g, new Date().getFullYear())
      .replace(/{{googleCalendarLink}}/g, googleLink)
      .replace(/{{outlookCalendarLink}}/g, outlookLink)
      .replace(/{{otherCalendarLink}}/g, otherLink) // Added replacement for the 'Other' calendar link
      .replace(/{{counsellorName}}/g, session.counsellorName || 'GetNextVisa Expert')
      .replace(/{{meetingTopic}}/g, session.subject || 'Visa Consultation')
      .replace(/{{meetingDateTime}}/g, `${sessionDateTime.toLocaleDateString('en-GB')} at ${sessionDateTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`)
      .replace(/{{meetingDuration}}/g, `${session.duration || '30'} minutes`)
      .replace(/{{platformName}}/g, session.mode || 'Online');
};


const EmailModal = ({ session, onClose, onSend }) => {
    const [subject, setSubject] = useState('');
    const [htmlBody, setHtmlBody] = useState('');
    
    useEffect(() => {
        if (session && session.dateTime) {
            const formattedDate = new Date(session.dateTime).toLocaleDateString('en-GB');
            setSubject(`Regarding your session on ${formattedDate}`);
            // Pass a mock session object for demonstration if needed
            const mockSession = {
                ...session,
                subject: session.subject || 'Visa Consultation',
                duration: session.duration || '45',
                zoomMeetingLink: session.zoomMeetingLink || 'https://zoom.us/j/1234567890',
                counsellorName: session.counsellorName || 'Jane Doe',
                mode: 'Online'
            };
            setHtmlBody(generatePopulatedHtml(mockSession));
        }
    }, [session]);

    const handleSend = () => {
        if (!subject || !htmlBody) {
            alert('Please ensure the subject and body are not empty.');
            return;
        }
        onSend({ subject, body: htmlBody });
    };

    if (!session) return null;

    return (
        <div className="email-modal__overlay" onClick={onClose}>
            <div className="email-modal__content" onClick={e => e.stopPropagation()}>
                <div className="email-modal__header">
                    <h2 className="email-modal__title">Send Email to {session.studentName}</h2>
                    <div className="email-modal__header-actions">
                        <button className="email-modal__btn email-modal__btn--edit">
                            <span className="email-modal__icon-pencil"></span>
                            Edit Template
                        </button>
                        <button className="email-modal__btn--close" onClick={onClose}>×</button>
                    </div>
                </div>

                <div className="email-modal__body">
                    <div className="email-modal__subject-line">
                        <strong>Subject:</strong> {subject}
                    </div>
                    <div className="email-modal__preview-container">
                        <iframe
                            srcDoc={htmlBody}
                            title="Email Preview"
                            className="email-modal__preview-iframe"
                        />
                    </div>
                </div>

                <div className="email-modal__footer">
                    <button className="email-modal__btn email-modal__btn--action" onClick={handleSend}>
                        Send Email
                    </button>
                    <button className="email-modal__btn email-modal__btn--action" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmailModal;